/**
 * Custom error class for Dune.
 */
export default class DuneError extends Error {}
